import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn,Button } from "../components";
import { HeaderThree, BlogOne, FooterTwo } from "../containers";
const Blog = () => (
  <Fragment>
    <Seo
  title="Tech Ayukta Blogs — Technology, ERP, SAP, Web & App Development Insights"
  description="Read the latest Tech Ayukta blogs on SAP solutions, ERP implementation, IT consulting, custom software development, web and mobile app development, cloud technologies, cybersecurity, and digital transformation strategies for modern businesses."
  keywords="
    Tech Ayukta Blog,
    Tech Ayukta Articles,
    ERP Solutions Blog,
    SAP Training Blog,
    SAP Implementation Insights,
    IT Consulting Blog,
    Web Development Blog,
    Mobile App Development Blog,
    Software Development Blog,
    Cloud Computing Insights,
    Cybersecurity Tips,
    Digital Transformation Strategies,
    Business Automation Blogs,
    Technology Trends,
    Modern IT Solutions,
    Enterprise Software Insights,
    IT Industry Updates
  "
  canonical="https://www.techayukta.com/blog"
/>

    <HeaderThree />
    <Breadcrumb
      pageName="Blog List"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
   <div className="container mt-3 d-none d-md-block">
    <Button path="/blog-grid">Blog Grid View<i className="far fa-arrow-right"/></Button>
   </div>
    <BlogOne className="space-top space-extra-bottom pt-5 pt-md-2" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Blog;
